// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message-card[data-v-36f41930]{max-width:747px;height:auto;flex-direction:column}@media(max-width:767px){.message-card[data-v-36f41930]{max-width:unset;max-height:unset}}.message-card__img[data-v-36f41930]{width:120px}@media screen and (max-width:991px)and (orientation:landscape),screen and (max-width:991px)and (orientation:portrait){.message-card[data-v-36f41930]{padding:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
